import React, { useState } from "react";
import { Box, Card, Divider } from "@material-ui/core";
import {
  makeStyles,
  lighten,
  ThemeProvider,
  createTheme
} from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import EditIcon from "@material-ui/icons/Edit";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { green } from "@material-ui/core/colors";

import PageLoader from "@jumbo/components/PageComponents/PageLoader";
import api from "services/api";
import { getToken } from "services/auth";
import Swal from "sweetalert2";
import Switch from "@material-ui/core/Switch";
import InputAdornment from "@material-ui/core/InputAdornment";
import { FormatColorText } from "@material-ui/icons";

const schema = yup
  .object({
    desc: yup.string().required("Descrição é obrigatório")
  })
  .required();

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    marginTop: 25,
    overflow: "overlay"
  },
  bancoHoras: {
    display: "flex",
    flexDirection: "column",
    marginTop: "35px",
    marginBottom: "35px"
  },
  tolerancia: {
    marginBottom: "35px"
  },
  rootCard: {
    minWidth: 200,
    maxWidth: 300,
    margin: "0 auto",
    backgroundColor: lighten(theme.palette.background.paper, 0.1)
  },
  fieldHours: {
    marginTop: 20,
    minWidth: "20ch"
  },
  horaExtra: {
    marginTop: 40,
    padding: 20,
    minWidth: "20ch"
  },
  button: {
    marginTop: 10,
    minWidth: "30ch"
  },
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: theme.spacing(4),
    flex: 1
  },
  titleCard: {
    marginTop: "30px",
    marginLeft: "25px"
  },
  textSave: {
    color: "white"
  },
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  header: {
    backgroundColor: "#f4f4f7"
  },
  textFieldLarge: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(4),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(4),
    width: 400,
    "& p": {
      color: "red"
    }
  },
  boxBancoHoras: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "10px"
  },
  boxTolerancia: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "10px"
  },
  percent: {
    fontWeight: "bold",
    fontSize: "1.1em"
  },
  scroll: {
    overflow: "visible"
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const theme = createTheme({
  palette: {
    primary: green
  }
});

export default function UpdateEscala(props) {
  const classes = useStyles();
  const headers = { Authorization: "Bearer " + getToken() };
  const [isLoading, setIsLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const onChangeItem = props.onChangeItem;
  const [dataDias, setDataDias] = useState([]);
  const [dataBanco, setDataBanco] = useState([]);
  const [dataTolerancia, setDataTolerancia] = useState([]);
  const [nomeEscala, setNomeEscala] = useState(props.descricao);
  const [nome, setNome] = useState(props.descricao);
  const id = props.id;

  const [bancoHoras, setBancoHoras] = useState(false);
  const [limite, setLimite] = useState(false);
  const [aplicaLimite, setAplicaLimite] = useState(false);
  const [debitaAtrasos, setDebitaAtrasos] = useState();
  const [debitaFaltas, setDebitaFaltas] = useState();
  const [tempoLimite, setTempoLimite] = useState();

  const [tempoMaximo, setTempoMaximo] = useState();
  const [atrasoEntrada, setAtrasoEntrada] = useState();
  const [extraEntrada, setExtraEntrada] = useState();
  const [atrasoIntervalo, setAtrasoIntervalo] = useState();
  const [extraIntervalo, setExtraIntervalo] = useState();
  const [atrasoSaida, setAtrasoSaida] = useState();
  const [extraSaida, setExtraSaida] = useState();

  const [checkId, setCheckId] = useState(false);
  const [disableCampos, setDisableCampos] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const handleDiaUtil = (valor, index) => {
    setLimite(valor);
    setCheckId(index);
    setDisableCampos(valor);
  };

  const handleBancoHoras = e => {
    setBancoHoras(e.target.checked);
  };

  const handleClickOpen = () => {
    setOpen(true);
    getEscalaById();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAplicaLimite = e => {
    setAplicaLimite(e.target.checked);
  };

  const handleAtrasos = e => {
    setDebitaAtrasos(e.target.checked);
  };

  const handleFaltas = e => {
    setDebitaFaltas(e.target.checked);
  };

  const getEscalaById = async () => {
    try {
      api
        .get(`ponto/escalas/${id}`, { headers })
        .then(response => {
          setDataDias(response.data.data[0]["escalaHoras"]);
          setDataBanco(response.data.data[0]["banco"][0]);
          setBancoHoras(response.data.data[0]["banco"][0]["banco_horas"]);

          setLimite(response.data.data[0]["banco"][0]["banco_horas"]);
          setDebitaAtrasos(
            response.data.data[0]["banco"][0]["debita_hora_atraso"]
          );
          setDebitaFaltas(response.data.data[0]["banco"][0]["debita_falta"]);
          setAplicaLimite(response.data.data[0]["banco"][0]["aplicar_limite"]);
          setTempoLimite(
            response.data.data[0]["banco"][0]["tempo_limite_diario"]
          );

          setDataTolerancia(response.data.data[0]["tolerancia"][0]);
          setTempoMaximo(
            response.data.data[0]["tolerancia"][0]["tempo_maximo_tolerancia"]
          );
          setAtrasoEntrada(
            response.data.data[0]["tolerancia"][0]["atraso_entrada"]
          );
          setExtraEntrada(
            response.data.data[0]["tolerancia"][0]["extra_entrada"]
          );
          setAtrasoIntervalo(
            response.data.data[0]["tolerancia"][0]["atraso_intervalo"]
          );
          setExtraIntervalo(
            response.data.data[0]["tolerancia"][0]["extra_intervalo"]
          );
          setAtrasoSaida(
            response.data.data[0]["tolerancia"][0]["atraso_saida"]
          );
          setExtraSaida(response.data.data[0]["tolerancia"][0]["extra_saida"]);
          setNomeEscala(response.data.data[0]["base"]["nome"]);

          setIsLoading(false);
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#3085D6",
            title: "Oops...",
            text: "Não conseguimos consultar a escala"
          });
        });
    } catch (err) {
      Swal.fire({
        icon: "error",
        confirmButtonColor: "#3085D6",
        title: "Oops...",
        text: "Não conseguimos conectar na api"
      });
    }
    setIsLoading(true);
  };

  const handleCadastrar = () => {
    try {
      api
        .patch(
          `ponto/escalas/${id}`,
          {
            descricao: nome,
            dataDias,
            id_banco: dataBanco.id,
            banco_horas: bancoHoras,
            debita_hora_atraso: debitaAtrasos,
            debita_falta: debitaFaltas,
            aplicar_limite: limite,
            tempo_limite_diario: tempoLimite,
            id_tolerancia: dataTolerancia.id,
            tempo_maximo_tolerancia: tempoMaximo,
            atraso_entrada: atrasoEntrada,
            extra_entrada: extraEntrada,
            atraso_intervalo: atrasoIntervalo,
            extra_intervalo: extraIntervalo,
            atraso_saida: atrasoSaida,
            extra_saida: extraSaida
          },
          { headers }
        )
        .then(res => {
          setIsLoading(false);
          Swal.fire({
            icon: "success",
            confirmButtonColor: "#3085d6",
            title: "Uhul!",
            text: "Escala atualizada."
          });
          handleClose();
          onChangeItem({ nome: nome });
        })
        .catch(err => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#3085d6",
            title: "Oops...",
            text: "Não conseguimos atualizar a escala" + err
          });
        });
    } catch (err) {
      Swal.fire({
        icon: "error",
        confirmButtonColor: "#3085D6",
        title: "Oops...",
        text: "Não conseguimos conectar na api"
      });
    }
    handleClose();
    onChangeItem({ nome: nome });
  };

  return (
    <Box>
      <IconButton
        color="primary"
        aria-label="Editar Escala"
        title="Editar Escala"
        onClick={handleClickOpen}
      >
        <EditIcon fontSize="large" />
      </IconButton>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        aria-labelledby="escala"
        fullWidth
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {" "}
              Editar Escala{" "}
            </Typography>
            <ThemeProvider theme={theme}>
              <Button
                variant="contained"
                color="primary"
                className={(classes.margin, classes.textSave)}
                onClick={handleSubmit(handleCadastrar)}
              >
                Salvar
              </Button>
            </ThemeProvider>
          </Toolbar>
        </AppBar>
        <DialogContent>
          {isLoading != true ? (
            <div>
              <TextField
                autoFocus
                autoComplete={"off"}
                variant="outlined"
                id="nova_desc"
                label="Descrição Escala"
                type="text"
                defaultValue={nomeEscala}
                className={classes.textFieldLarge}
                name="desc"
                error={errors.desc ? true : false}
                helperText={errors.desc?.message}
                {...register("desc", {
                  required: true,
                  onChange: e => setNome(e.target.value),
                  shouldUnregister: true
                })}
              />
              <Card variant="outlined">
                <h2 className={classes.titleCard}>Dias/Horas</h2>
                <CardContent className={classes.root}>
                  {dataDias.map((dia, index) => (
                    <Card id={index} key={index} sx={{ maxWidth: 345 }} className={classes.scroll}>
                      <CardHeader className={classes.header} title={dia.dscDiaSemana.nome} />
                      <Divider />
                      <CardContent className={classes.rootCard}>
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              onChange={e => {
                                dia["dia_util"] = e.target.checked;
                                handleDiaUtil(e.target.checked, dia.id);
                              }}
                              inputProps={{
                                "aria-label": "controlled"
                              }}
                              checked={dia.dia_util}
                            />
                          }
                          label="Dia útil?"
                        />
                        <TextField
                          id="time"
                          label="Entrada"
                          type="time"
                          className={classes.fieldHours}
                          InputLabelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            step: 300 // 5 min
                          }}
                          onChange={e => {
                            dia["entrada"] = e.target.value;
                          }}
                          defaultValue={dia.entrada}
                          disabled={
                            dia.dia_util ||
                              disableCampos & (checkId === dia.id) ? (
                              false
                            ) : (
                              true
                            )
                          }
                        />
                        <TextField
                          id="time"
                          label="Início do Intervalo"
                          type="time"
                          className={classes.fieldHours}
                          InputLabelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            step: 300 // 5 min
                          }}
                          onChange={e => {
                            dia["entrada_intervalo"] = e.target.value;
                          }}
                          defaultValue={dia.saida_intervalo}
                          disabled={
                            dia.dia_util ||
                              disableCampos & (checkId === dia.id) ? (
                              false
                            ) : (
                              true
                            )
                          }
                        />
                        <TextField
                          id="time"
                          label="Fim do Intervalo"
                          type="time"
                          className={classes.fieldHours}
                          InputLabelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            step: 300 // 5 min
                          }}
                          onChange={e => {
                            dia["saida_intervalo"] = e.target.value;
                          }}
                          defaultValue={dia.entrada_intervalo}
                          disabled={
                            dia.dia_util ||
                              disableCampos & (checkId === dia.id) ? (
                              false
                            ) : (
                              true
                            )
                          }
                        />
                        <TextField
                          id="time"
                          label="Saída"
                          type="time"
                          className={classes.fieldHours}
                          InputLabelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            step: 300 // 5 min
                          }}
                          onChange={e => {
                            dia["saida"] = e.target.value;
                          }}
                          defaultValue={dia.saida}
                          disabled={
                            dia.dia_util ||
                              disableCampos & (checkId === dia.id) ? (
                              false
                            ) : (
                              true
                            )
                          }
                        />
                        <div className={classes.horaExtra}>
                          <TextField
                            className={classes.fieldHours}
                            type="number"
                            id="input-with-icon-textfield"
                            label="Horas extras"
                            defaultValue={dia["porcentagem"]}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <span className={classes.percent}>%</span>
                                </InputAdornment>
                              )
                            }}
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{
                              step: 0 // 5 min
                            }}
                            onChange={e => {
                              dia["porcentagem"] = e.target.value;
                            }}
                          />
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </CardContent>
              </Card>

              <Card className={classes.bancoHoras} variant="outlined">
                <h2 className={classes.titleCard}>Banco de Horas</h2>
                <CardContent>
                  <Box className={classes.boxBancoHoras}>
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={bancoHoras}
                          onChange={handleBancoHoras}
                          inputProps={{
                            "aria-label": "controlled"
                          }}
                        />
                      }
                      label="Tem banco de horas?"
                    />

                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={debitaAtrasos}
                          onChange={handleAtrasos}
                          disabled={bancoHoras ? false : true}
                          inputProps={{
                            "aria-label": "controlled"
                          }}
                        />
                      }
                      label="Debitar atrasos"
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={debitaFaltas}
                          onChange={handleFaltas}
                          disabled={bancoHoras ? false : true}
                          inputProps={{
                            "aria-label": "controlled"
                          }}
                        />
                      }
                      label="Debitar faltas"
                    />

                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={aplicaLimite}
                          onChange={handleAplicaLimite}
                          inputProps={{
                            "aria-label": "controlled"
                          }}
                        />
                      }
                      label="Aplicar limite?"
                    />

                    <TextField
                      id="tempoLimite"
                      disabled={aplicaLimite ? false : true}
                      label="Tempo limite diário"
                      type="time"
                      style={{ minWidth: "20ch" }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300 // 5 min
                      }}
                      onChange={e => setTempoLimite(e.target.value)}
                      defaultValue={tempoLimite}
                    />
                  </Box>
                </CardContent>
              </Card>

              <Card className={classes.tolerancia} variant="outlined">
                <h2 className={classes.titleCard}>Tempos de Tolerância</h2>
                <CardContent>
                  <Box className={classes.boxTolerancia}>
                    <TextField
                      id="tempoMaximo"
                      label="Tempo máximo diário"
                      type="time"
                      style={{ minWidth: "22ch" }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300 // 5 min
                      }}
                      onChange={e => setTempoMaximo(e.target.value)}
                      defaultValue={tempoMaximo}
                    />
                    <TextField
                      id="atrasoEntrada"
                      label="Atraso na entrada"
                      type="time"
                      style={{ minWidth: "22ch" }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300 // 5 min
                      }}
                      onChange={e => setAtrasoEntrada(e.target.value)}
                      defaultValue={atrasoEntrada}
                    />
                    <TextField
                      id="extraEntrada"
                      label="Extra na entrada"
                      type="time"
                      style={{ minWidth: "22ch" }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300 // 5 min
                      }}
                      onChange={e => setExtraEntrada(e.target.value)}
                      defaultValue={extraEntrada}
                    />
                    <TextField
                      id="atrasoIntervalo"
                      label="Atraso no intervalo"
                      type="time"
                      style={{ minWidth: "22ch" }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300 // 5 min
                      }}
                      onChange={e => setAtrasoIntervalo(e.target.value)}
                      defaultValue={atrasoIntervalo}
                    />
                    <TextField
                      id="extraIntervalo"
                      label="Extra no intervalo"
                      type="time"
                      style={{ minWidth: "22ch" }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300 // 5 min
                      }}
                      onChange={e => setExtraIntervalo(e.target.value)}
                      defaultValue={extraIntervalo}
                    />
                    <TextField
                      id="atrasoSaida"
                      label="Atraso na saída"
                      type="time"
                      style={{ minWidth: "22ch" }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300 // 5 min
                      }}
                      onChange={e => setAtrasoSaida(e.target.value)}
                      defaultValue={atrasoSaida}
                    />
                    <TextField
                      id="extraSaida"
                      label="Extra na saída"
                      type="time"
                      style={{ minWidth: "22ch" }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300 // 5 min
                      }}
                      onChange={e => setExtraSaida(e.target.value)}
                      defaultValue={extraSaida}
                    />
                  </Box>
                </CardContent>
              </Card>
            </div>
          ) : (
            <PageLoader />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
